// src/project/data/triggers/updateKyc.js
// Step 2 du flow KYC V3 : Mise à jour des données KYC
// POST /kyc/update/{kycId}
import { buildActionUrl, RIDER_ENDPOINTS, getUserId } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'

const formatDate = (dateStr) => {
  if (!dateStr) return null
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return null
  return date.toISOString().split('T')[0]
}

const idTypeMap = {
  "Carte nationale d'identité": 'national_id',
  Passeport: 'passport',
  'Permis de conduire': 'driving_license',
  Autre: 'national_id',
}

export default {
  postUrl(payload) {
    const userId = getUserId()
    const kycId = payload?.kycId || `kyc_rider_${userId}`
    return buildActionUrl(RIDER_ENDPOINTS.KYC_UPDATE(kycId))
  },
  format(payload) {
    const userId = getUserId()
    const kycId = payload?.kycId || `kyc_rider_${userId}`
    const nameParts = (payload.fullName || '').trim().split(/\s+/)
    const firstName = nameParts[0] || ''
    const lastName = nameParts.slice(1).join(' ') || ''
    const userData = Storage.get('userData')

    return {
      id: kycId,
      userId,
      userType: 'rider',
      data: {
        personalInfo: {
          firstName,
          lastName,
          phone: payload.phoneNumber?.replace(/[\s\-\(\)]/g, '') || userData?.phone || '',
          dateOfBirth: formatDate(payload.birthDate),
          nationality: payload.nationality || '',
          address: payload.address || '',
          city: payload.city || '',
        },
        identityDocument: payload.idType
          ? {
              type: idTypeMap[payload.idType] || 'national_id',
              number: payload.idNumber || '',
              frontPhotoUrl: payload.idFrontPhotoUrl || '',
              backPhotoUrl: payload.idBackPhotoUrl || '',
              expirationDate: formatDate(payload.idExpiryDate),
            }
          : {},
        vehicleDocument: payload.vehicleRegistration
          ? {
              type: 'registration',
              number: payload.vehicleRegistration || '',
              photoUrl: payload.vehiclePhotoUrl || '',
            }
          : {},
        selfieUrl: payload.selfieUrl || '',
      },
    }
  },
  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        data: { saved: false, message: raw?.message || 'Erreur lors de la mise à jour du KYC' },
      }
    }
    return {
      statusCode: 200,
      data: {
        saved: true,
        kyc: raw?.data || null,
        kycId: raw?.data?.id || null,
        message: 'KYC mis à jour',
      },
    }
  },
}
